<template>
  <div id="contentt">
      <div class="productbg">
        <img src="../images/productbg.jpg" />
      </div>
      
      <div class="productcenterdiv">
    <div id="producttwodetail">
    <!-- <div class="nav_prodtwo" v-if="$i18n.locale == 'en'">
       Position: <a href="/#/product"><span>Product</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.smallclassid_name}}</span></a> > <span>{{porduct.prod_enname}}</span>
   </div> -->
    <!-- <div class="nav_prodtwo" v-else>  
      你当前的位置：<a href="/#/product"><span>色母粒系列</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.smallclassid_name}}</span></a> > <span>{{porduct.prod_name}}</span>
   
     </div> -->
      
      <div class="producttwo_1">
        <div class="product_101" v-if="$i18n.locale == 'en'">
          {{ porduct.prod_enname }}
        </div>
        <div v-else class="product_101">{{ porduct.prod_name }}</div>
        <div class="prodtwo le">
          <div
            class="tempWrap"
          >
          
    <!-- <div v-if="$i18n.locale == 'en'"  class="producttwo_104"  v-html="porduct.prod_reRemark">
    </div>
    <div  v-else  class="producttwo_104" v-html="porduct.prod_remark">
    </div> -->
            <!-- <ul
            >
             <li v-for="p in porduct.images" :key="p" style="height: 750px">
                <img
                  :src="p"
                />
              </li>
            </ul> -->
          </div>
        </div>
        <div class="clear"></div>
      </div>
      
    <div v-if="$i18n.locale == 'en'"  class="producttwo_104"  v-html="porduct.prod_content_en">
    </div>
    <div  v-else  class="producttwo_104" v-html="porduct.prod_content">
    </div>
    </div>
    <div class="productcenterrightdiv">
      <div class="navtwo_1">
      <div class="productTwoNav">
        {{ $t("header.yiyong") }}
      </div>
        <div v-for="cl in classs"
             :key="cl.ID">
               <a :href="'/#/producttwodetail/'+cl.ID" target="_blank">
                <img :src="cl.prod_image"
                   alt="" />
            <span v-if="$i18n.locale == 'en'">{{ cl.prod_enname }}</span>
            <span v-else>{{ cl.prod_name }}</span>
          </a>
        </div>
        <!-- <a href="list.php?pid=2&amp;ty=13" class="on">遥控车系列</a> -->
        <div class="clear"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "ProductDetail",
  data() {
    return {
      porduct: {},
      classs:[]
    };
  },
  mounted() {
    // 使用
    
    const keywordinfo = { 'bigclassid':2 };
    const productparam = { page_index: 1, page_size: 90, keyword: JSON.stringify(keywordinfo) }; // 参数
    fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
      (res) => {
        this.classs = res.Items;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    const params = { id: this.$route.params.id }; // 参数
    fetch.post("/api/ApiProduct/Get", params).then(
      (res) => {
        this.porduct = res; 
        if(this.porduct.images.length>1)
      {
        setTimeout(function () {
          jQuery(".producttwo_1").slide(
            {
              effect: "topLoop",
              mainCell: ".prodtwo ul",
              autoPlay: true,
              interTime: 5500,
              vis: 1,
              scroll: 1,
              easing: "swing",
              trigger: "mouseover",
            },
            500
          );
        });
      }
    },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
};
</script>

<style>
#producttwodetail {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 70%;
}
.producttwo_1 {
  width: 100%;
  margin: 20px auto auto;
}
.product_101 {
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 30px;
  line-height: 32px;
  margin-bottom: 20px;
  font-weight: bolder
}

.prodtwo {
  width: 100%;
}
.prodtwo li {
  width: 100%;
}
.prodtwo li img {
  display: block;
  overflow: hidden;
  width: 100%;
  height: 750px !important;
}
.producttwo_1 .hd {
  width: 350px;
}
.producttwo_1 .hd li {
  text-align: right;
  margin-bottom: 10px;
  width: 314px;
  height: 225px;
  overflow: hidden;
}
.producttwo_1 .hd li img {
  width: 300px;
  height: 223px;
  border: 1px #f5f5f5 solid;
}
.producttwo_1 .hd li:hover {
  background: url(../images/prod01.jpg) no-repeat left center;
}
.producttwo_1 .hd li:hover img {
  border: 1px #01a4e9 solid;
}
.producttwo_1 .hd li.on {
  background: url(../images/prod01.jpg) no-repeat left center;
}
.producttwo_1 .hd li.on img {
  border: 1px #01a4e9 solid;
}

.producttwo_102 {
  text-align: left;
  width: 1320px;
  margin: 20px auto auto;
  font-size: 16px;
  color: #666;
  line-height: 30px;
  height: auto !important;
  min-height: 200px;
  _height: 200px;
  display: none;
}
.producttwo_103 {
  width: 1320px;
  margin-bottom: 20px;
  font-weight: bold;
  margin: 20px auto auto;
}

.producttwo_104 {
  width: 100%;
  padding: 18px 0;
  border-top: 1px #ccc dashed;
  text-align: left;
  text-indent: 20px;
  
}
.nav_prodtwo  {
  font-size: 14px;
  color: #333;
  width: 1300px;
  height: 32px;
  text-align: left;
  line-height: 32px;
  background: #e6e6e6;
  border-bottom: 3px #dbdbdb solid;
  margin: 30px auto auto;
  padding-left:30px ;
}

.productbg{
  margin: 0px;
padding: 0px;
height: 300px;
}
.productbg img{
  margin: 0px;
padding: 0px;
}
   .producttwo_104 table {
        width: 400px;
        margin: 0 auto;
        border: 1px solid #000000;
        border-collapse: collapse;
    }
    
   .producttwo_104 th,.producttwo_104 td {
        border: 1px solid #000000;
        text-align: center;
    }
    
.productcenterdiv {
  width: 1400px;
  display: flex;
  margin: 0 auto;
}

.productcenterrightdiv
{
  width: 26%;
  margin-left: 30px;
}

.productTwoNav{
  background-color: blue;
  color: white;
  font-weight: bolder;
  font-size: 30px;
  margin-top: 75px;
  width: 100%;  line-height: 80px;
  text-indent: 20px;
  position: relative;border-radius:  0  20px 0 0;
}

.productcenterrightdiv .navtwo_1 img{
  width: 100%;
  height: 200px;
}

.navtwo_1 a {
  display: block;
  float: left;
  text-align: left;
  font-size: 16px;
  color: #333;
  width: 100%;  
  line-height: 30px;
  background: white;
  border-bottom: 1px #dbdbdb solid;
  margin-bottom: 10px;
}
.navtwo_1 a span{
  padding-left:  20px;
}
.navtwo_1 a:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
.navtwo_1 a.on {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductTwoDetail.vue